import { getBackendUrl } from "@/lib/backend-url";

export interface PublicSuccessStory {
  id: string;
  name: string;
  role: string;
  image: string;
  quote: string;
  companyName?: string;
  designation?: string;
  packageAmount?: string;
  courseName?: string;
  placementDate?: string;
}

export interface PublicCourse {
  id: string;
  name: string;
  slug: string;
  description: string;
  subtitle?: string;
  duration: string;
  level: string;
  priceDisplay: string;
  priceAmount?: number;
  priceCompareNote?: string;
  emi?: string;
  rating: number;
  reviews: number;
  studentsEnrolled: number;
  lastUpdated?: string;
  thumbnail?: string;
  whatYouWillLearn: string[];
  curriculum: { title: string; lessons: number; duration: string }[];
  isActive: boolean;
  sortOrder: number;
}

export async function fetchPublicCourses(): Promise<PublicCourse[]> {
  try {
    const response = await fetch(
      `${getBackendUrl()}/api/v1/catalog/courses?limit=50&sortBy=sortOrder&sortDir=asc`,
      { next: { revalidate: 0 } }, // no cache — always fresh
    );
    if (!response.ok) return [];
    const payload = await response.json();
    return (payload.data?.items ?? []) as PublicCourse[];
  } catch {
    return [];
  }
}

export async function fetchPublicSuccessStories(): Promise<PublicSuccessStory[]> {
  try {
    const response = await fetch(`${getBackendUrl()}/api/v1/catalog/success-stories`, {
      next: { revalidate: 60 },
    });
    if (!response.ok) {
      return [];
    }
    const payload = await response.json();
    const stories: PublicSuccessStory[] = payload.data ?? [];
    // Normalise missing images to initials avatar so <Image> never gets an empty src
    return stories.map((s) => ({
      ...s,
      image: s.image?.trim()
        ? s.image
        : `https://ui-avatars.com/api/?name=${encodeURIComponent(s.name ?? "A")}&background=6c5ce7&color=fff`,
    }));
  } catch {
    return [];
  }
}
